import { apiClient } from './client';
import { API_CONFIG } from './config';

export type CustomerEntity = {
  userId: string;
  name: string;
  email: string;
  username: string;
  role: string;
  status: string;
  phoneNo: string | null;
  address: string | null;
  country: string | null;
  dob: string | null;
  type: string | null;
  title: string | null;
  description: string | null;
  occupation: string | null;
  profilePicture: string | null;
  createdAt: string;
  updatedAt: string;
  [key: string]: unknown;
};

export type CustomersListResponse = {
  data: CustomerEntity[];
  total: number;
  skip: number;
  limit: number;
};

export type CreateCustomerRequest = {
  name: string;
  email: string;
  password?: string;
  phoneNo?: string;
  address?: string;
  country?: string;
  status?: string;
  [key: string]: unknown;
};

export type UpdateCustomerRequest = Partial<CreateCustomerRequest>;

class CustomersApi {
  private ep = API_CONFIG.endpoints.customers;

  list(params?: { skip?: number; limit?: number; search?: string }) {
    return apiClient.get<CustomersListResponse>(this.ep.list, { params });
  }

  adminList(params?: { skip?: number; limit?: number; search?: string }) {
    return apiClient.get<CustomersListResponse>(this.ep.adminList, { params });
  }

  getById(id: string) {
    return apiClient.get<CustomerEntity>(this.ep.byId(id));
  }

  create(data: CreateCustomerRequest) {
    return apiClient.post<CustomerEntity>(this.ep.create, data);
  }

  update(id: string, data: UpdateCustomerRequest) {
    return apiClient.patch<CustomerEntity>(this.ep.update(id), data);
  }
}

export const customersApi = new CustomersApi();
